import _classCallCheck from "/home/rich/projects/django-doctor-website/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _possibleConstructorReturn from "/home/rich/projects/django-doctor-website/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/home/rich/projects/django-doctor-website/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
import _inherits from "/home/rich/projects/django-doctor-website/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";
import _assertThisInitialized from "/home/rich/projects/django-doctor-website/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/assertThisInitialized";
import _wrapNativeSuper from "/home/rich/projects/django-doctor-website/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/wrapNativeSuper";

var Deprecation = /*#__PURE__*/function (_Error) {
  _inherits(Deprecation, _Error);

  function Deprecation(message) {
    var _this;

    _classCallCheck(this, Deprecation);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(Deprecation).call(this, message)); // Maintains proper stack trace (only available on V8)

    /* istanbul ignore next */

    if (Error.captureStackTrace) {
      Error.captureStackTrace(_assertThisInitialized(_assertThisInitialized(_this)), _this.constructor);
    }

    _this.name = 'Deprecation';
    return _this;
  }

  return Deprecation;
}(_wrapNativeSuper(Error));

export { Deprecation };